/**
 * A home's price on the builder's website: UGX, with the website's other
 * currency under it — or leading, when the builder chose that currency to
 * lead (Nakasero Estates, Oct 2026: "2 billion UGX feels a lot; 500,000 USD
 * sounds small"). A reserved home shows no price at all.
 */

import type { WebForeign } from "@/lib/config/builderSite";
import { foreignText, ugx } from "../theme";

export default function HomePrice({ price, foreign, reserved }: { price: number; foreign?: WebForeign; reserved?: boolean }) {
  if (reserved) return <span className="font-normal text-[var(--b-muted)]">Reserved</span>;
  if (!foreign) return <>{ugx(price)}</>;
  return (
    <span className="inline-block text-right">
      <span className="block">{foreign.first ? foreignText(foreign) : ugx(price)}</span>
      <span className="block text-xs font-normal text-[var(--b-muted)]">{foreign.first ? ugx(price) : foreignText(foreign)}</span>
    </span>
  );
}
